<template>
    <div class="modal" :class="{'is-active': isActive}" v-if="true" v-e2e="'modal-dashboard-gestor-relatorio'">
      <div class="modal-background" v-e2e="'modal-dashboard-gestor-relatorio-background'"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Relatório eTarefas</p>
          <button class="delete" aria-label="fechar" title="Fechar" @click="doCancelar" v-e2e="'modal-dashboard-gestor-relatorio-btn-fechar'"></button>
        </header>
        <section class="modal-card-body">
          <div class="columns is-multiline my-0">
            <div class="column is-3">
              <label class="has-whitespace-nowrap">
                Colaborador
                <span class="button is-loading is-white pl-2 pr-2 is-inline-block" style="height: 1.25em" v-if="loads.colaboradores"></span>
              </label>
            </div>
            <div class="column is-9">
              <Multiselect
                v-e2e="'trf-modal-relatorios-gestor-select-colaboradores'"
                class="multiselect-econtador is-multiple"
                :class="{'error-input': isColaboradoresInvalidos && isFormDirty}"
                mode="multiple"
                placeholder="Selecione o(s) colaborador(es)..."
                :close-on-select="false"
                :options="listaDeColaboradores"
                :loading="loads.colaboradores"
                :disabled="loads.colaboradores"
                :hideSelected="false"
                :searchable="true"
                noOptionsText="Nenhum colaborador disponível"
                v-model="formData.usuariosIds"
                ref="modalRelatorioColaboradores"
                @select="tratarSelecaoColaborador"
              >
                <template #multiplelabel="{ values }">
                  <div class="multiselect-multiple-label">
                    {{ adquirirLabelColaboradoresSelecionados(values) }}
                  </div>
                </template>

                <template #option="{ option }">
                  <p :title="option.title? option.title : option.label">{{ option.label }}</p>
                </template>
              </Multiselect>
              <p v-if="isColaboradoresInvalidos && isFormDirty" v-e2e="'trf-modal-relatorios-gestor-mensagem-erro-colaborador'" class="error-message">
                Campo obrigatório
              </p>
            </div>
            <div class="column is-3">
              <label class="has-whitespace-nowrap">
                Tipo de relatório
                <span class="button is-loading is-white pl-2 pr-2 is-inline-block" style="height: 1.25em" v-if="loads.tipoRelatorio"></span>
              </label>
            </div>
            <div class="column is-9">
              <Multiselect
                v-e2e="'trf-modal-relatorios-gestor-select-tipo'"
                class="multiselect-econtador"
                :class="{'error-input': isTipoRelatorioInvalido && isFormDirty}"
                placeholder="Selecione o(a) tipo de relatório..."
                :hideSelected="false"
                :options="listaDeRelatorios"
                :loading="loads.tipoRelatorio"
                :disabled="loads.tipoRelatorio"
                :searchable="true"
                noOptionsText="Nenhum tipo de formulário disponível"
                ref="modalRelatorioTipo"
                v-model="formData.tipoDeRelatorioId"
              ></Multiselect>
              <p v-if="isTipoRelatorioInvalido && isFormDirty" v-e2e="'trf-modal-relatorios-gestor-mensagem-erro-tipo'" class="error-message">
                Campo obrigatório
              </p>
            </div>
            <div class="column is-3">
              <label>Período</label>
            </div>
            <div class="column is-9 columns is-multiline">
                <div class="column" :class="{'pb-0': isPeriodoInvalido && isFormDirty}">
                  <input
                    v-e2e="'trf-modal-relatorios-gestor-input-data-inicial'"
                    type="date"
                    class="input"
                    :class="{'error-input': isPeriodoInvalido && isFormDirty}"
                    v-model="formData.de"
                    :max="formData.ate"
                  />
                </div>
                <div class="column" :class="{'pb-0': isPeriodoInvalido && isFormDirty}">
                  <input
                    v-e2e="'trf-modal-relatorios-gestor-input-data-final'"
                    type="date"
                    class="input"
                    :class="{'error-input': isPeriodoInvalido && isFormDirty}"
                    v-model="formData.ate"
                    :min="formData.de"
                  />
                </div>
                <div class="column is-12 pt-0" v-if="isPeriodoInvalido && isFormDirty">
                  <p class="error-message" v-e2e="'trf-modal-relatorios-gestor-mensagem-erro-periodo'">{{ mensagemDeErroPeriodo }}</p>
                </div>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot buttons">
          <div class="buttons ml-auto">
            <TrfButton
              nome="Confirmar"
              :temIcon="false"
              id="btn-confirmar-geracao-relatorio"
              type="button"
              classCor="is-primary"
              :disabled="isLoading || hasDadosCarregandos"
              :isBtnLoading="isLoading"
              @click="async ($event) => await doGerarRelatorio($event)"
              v-e2e="'modal-dashboard-gestor-relatorio-btn-salvar'"
            />
            <TrfButton
              nome="Cancelar"
              :temIcon="false"
              id="btn-cancelar-geracao-relatorio"
              type="button"
              :disabled="isLoading"
              @click.prevent="doCancelar"
              v-e2e="'modal-dashboard-gestor-relatorio-btn-cancelar'"
            />
          </div>
        </footer>
      </div>
    </div>
</template>
<script>
import { defineAsyncComponent } from 'vue';
import { toastUtils } from '../../../../util/toast.utils.js';
import { pessoaLogada } from '../../../../stateManagement/pessoaLogada.js';
import { liderancasStore } from '../../../../stateManagement/liderancas.js';

export default {
  name: 'TrfDashboardGestorModalRelatorio',
  emits: ['trf-modal-gerar-relatorio-gestor-closed', 'trf-modal-gerar-relatorio-gestor-success'],
  components: {
    Multiselect: defineAsyncComponent(() => import('@vueform/multiselect')),
    TrfButton: defineAsyncComponent(() => import('../../../../components/Button/index.vue')),
  },
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {
        usuariosIds: [],
        tipoDeRelatorioId: null,
        de: '',
        ate: ''
      },
      validations: {
        colaboradores: false,
        tipoRelatorio: false,
        periodo: false
      },
      dados: {
        colaboradores: [],
        tiposDeRelatorio: [],
      },
      loads: {
        colaboradores: true,
        tipoRelatorio: true
      },
      isFormDirty: false,
      isLoading: false
    };
  },
  computed: {
    listaDeColaboradores() {
      let colaboradores = [
        {
          label: 'Todos os colaboradores',
          value: -1
        },
        {
          label: 'Sem responsável (A.V.A)',
          title: 'Assistente Virtual da Alterdata - AVA',
          value: -2,
          disabled: this.isTodosOsColaboradoresSelecionado
        }
      ]
      if(Array.isArray(this.dados.colaboradores)) {
        for(let colaborador in this.dados.colaboradores) {
          const colaboradorAtual = this.dados.colaboradores[colaborador];
          colaboradorAtual.disabled = this.isTodosOsColaboradoresSelecionado;
          colaboradores.push(colaboradorAtual)
        }
      }
      return colaboradores
    },
    listaDeRelatorios() {
      if (!Array.isArray(this.dados.tiposDeRelatorio) || this.dados.tiposDeRelatorio.length == 0) return [];
      const tipos = [];
      for (let tipo in this.dados.tiposDeRelatorio) {
        const tipoObj = this.dados.tiposDeRelatorio[tipo];
        tipos.push({
          label: tipoObj.descricao,
          value: tipoObj.id
        })
      }
      return tipos
    },
    isTodosOsColaboradoresSelecionado() {
      const isArray = Array.isArray(this.formData.usuariosIds);
      const isSelecionado = isArray && this.formData.usuariosIds.some(colaborador => colaborador == -1);
      return isSelecionado;
    },
    dataDeAsDate() {
      if(!this.formData.de) return null;
      const dataDe = new Date(this.formData.de);
      dataDe.setHours(0);
      dataDe.setMinutes(0);
      dataDe.setSeconds(0);
      dataDe.setMilliseconds(0)

      return dataDe;
    },
    dataAteAsDate() {
      if(!this.formData.ate) return null;

      const dataAte = new Date(this.formData.ate);
      dataAte.setHours(0);
      dataAte.setMinutes(0);
      dataAte.setSeconds(0);
      dataAte.setMilliseconds(0)

      return dataAte;
    },
    isPeriodoInvalido() {
      return !this.formData.de || !this.formData.ate || this.dataDeAsDate > this.dataAteAsDate;
    },
    isColaboradoresInvalidos() {
      return !Array.isArray(this.formData.usuariosIds) || this.formData.usuariosIds.length == 0 
    },
    isTipoRelatorioInvalido() {
      return !this.formData.tipoDeRelatorioId
    },
    isFormValido() {
      return !this.isPeriodoInvalido && !this.isColaboradoresInvalidos && !this.isTipoRelatorioInvalido
    },
    mensagemDeErroPeriodo() {
      if (!this.formData.de && !!this.formData.ate) {
        return "Data inicial é obrigatória"
      }
      if (!this.formData.ate && !!this.formData.de) {
        return "Data final é obrigatória"
      }
      if (!this.formData.ate && !this.formData.de) {
        return "Campo obrigatório"
      }
      if (this.isPeriodoInvalido) {
        return "Data inicial não pode ser maior que data final"
      }
      return "Campo obrigatório"
    },
    hasDadosCarregandos() {
      return this.loads.colaboradores && this.loads.tipoRelatorio
    }
  },
  methods: {
    async importUsuarioService() {
      const { usuarioService } = await import('../../../../service/usuario-service.js');
      return usuarioService;
    },
    async importTiposRelatorioProdutividadeService() {
      const { tiposRelatorioProdutividadeService } = await import('../../../../service/tipos-relatorio-produtividade-service.js')
      return tiposRelatorioProdutividadeService;
    },
    async importGerarRelatorioService() {
      const { gerarRelatorioService } = await import('../../../../service/gerar-relatorio-service.js')
      return gerarRelatorioService;
    },
    async importDepartamentoService() {
      const { departamentoService } = await import('../../../../service/departamento-service.js');
      return departamentoService;
    },
    async carregarUsuarios() {
      try {
        if (Array.isArray(this.dados.colaboradores) && this.dados.colaboradores.length != 0) return;
        this.loads.colaboradores = true;
        const usuarioService = await this.importUsuarioService();
        let colaboradores = await usuarioService.listarResponsaveis(true);
        const pessoa = pessoaLogada.current;
        const isAdminOrSuperAdmin = pessoa && (pessoa.Administrador || pessoa.isSuperAdm);
        await liderancasStore.carregarLiderancas();
        const isLider = liderancasStore.isLider;
      
        if (isAdminOrSuperAdmin) {
            this.dados.colaboradores = colaboradores;
            this.loads.colaboradores = false;
            return;
        }
        if (isLider) {
          this.dados.colaboradores = colaboradores.filter(colaborador => {
            if (colaborador.acessaTodosDepartamentos) return true;
            const acessaDepartamento = Array.isArray(colaborador.idsDepartamentos) && colaborador.idsDepartamentos.some(id => liderancasStore.liderancasIds.includes(id));
            const eResponsavelDepartamento = Array.isArray(colaborador.idsDepartamentosResponsavel) && colaborador.idsDepartamentosResponsavel.some(id => liderancasStore.liderancasIds.includes(id));
            return acessaDepartamento || eResponsavelDepartamento;
          });
        } else {
          this.dados.colaboradores = [];
        }
      } catch(e) {
        console.warn("WARN: Ocorreu um erro ao carregar colaboradores para geração do relatório");
        this.dados.colaboradores = [];
      } finally {
        this.loads.colaboradores = false;
      }
    },
    async carregarTiposRelatorio() {
      try {
        if (Array.isArray(this.dados.tiposDeRelatorio) && this.dados.tiposDeRelatorio.length != 0) return;
        this.loads.tipoRelatorio = true;
        const tiposRelatorioProdutividadeService = await this.importTiposRelatorioProdutividadeService();
        this.dados.tiposDeRelatorio = await tiposRelatorioProdutividadeService.listar();
      } catch(e) {

      } finally {
        this.loads.tipoRelatorio = false;
      }
    },
    adquirirLabelColaboradoresSelecionados(valores) {
      if(!Array.isArray(valores) || valores.length == 0) return "Selecione um ou mais colaboradores";
      if(valores.find((valor) => valor.value == -1)) {
        return "Todos os colaboradores"
      }
      if(valores.length == 1) {
        return valores[0].label
      }
      if(valores.length == 2) {
        return `${valores[0].label}, ${valores[1].label}`  
      }
      return `${valores.length} selecionados`
    },
    tratarSelecaoColaborador(valor) {
      const selectRef = this.$refs.modalRelatorioColaboradores;
      if(!selectRef) return;
      if(valor === -1 && Array.isArray(this.formData.usuariosIds) && this.formData.usuariosIds.length > 1) {
        selectRef.clear();
        selectRef.select(valor);
      }
    },
    async doGerarRelatorio() {
      try {
        this.isLoading = true;
        this.isFormDirty = true;
        if (!this.isFormValido) {
          throw new Error('Campos inválidos no formulário.\nVerifique e tente novamente.')
        }
        const gerarRelatorioService = await this.importGerarRelatorioService();
        await gerarRelatorioService.downloadRelatorioProdutividade(this.formData);
        toastUtils.successToast('Relatório gerado com sucesso!');
      } catch(e) {
        toastUtils.dangerToast(e)
      } finally {
        this.isLoading = false;
      }
    },
    doReset() {
      this.formData = {
        usuariosIds: [],
        tipoDeRelatorioId: null,
        de: '',
        ate: ''
      }
    },
    async doCancelar() {
      this.isFormDirty = false;
      this.isLoading = false;
      this.doReset();
      this.doFecharModal();
    },
    doFecharModal() {
      this.$emit('trf-modal-gerar-relatorio-gestor-closed', false)
    }
  },
  async mounted() {
    await this.carregarUsuarios()
    await this.carregarTiposRelatorio()
  }
};
</script>
<style lang="scss" scoped>
.has-whitespace-nowrap {
  white-space: nowrap;
}
.error-input {
  border-color: #a94442;
}
.error-input.is-active {
  box-shadow: 0 0 0 var(--ms-ring-width, 3px) #a9444266;
}
.error-message {
  margin: 0 0 1% 0;
  color: #a94442;
  font-size: 12px;
}
.error-label {
  color: #a94442;
}
</style>
